import {Modal} from "antd";
import {FaRegCircleXmark} from "react-icons/fa6";

const Fail = ({visible,onClose}) => {
    return (
        <Modal open={visible}
               onCancel={onClose}
               footer={null}
               className={"!w-fit"}>
            <div className={"text-center p-4"}>
                <FaRegCircleXmark className={"w-32 h-32 justify-center mx-auto text-red-400 mb-4"} />
                <h2 className={"text-2xl font-semibold text-gray-700 text-center"}>Bạn đã ứng tuyển công việc này rồi!</h2>
            </div>
        </Modal>
    )
}

export default Fail;